<template>
  <v-container class="filters col-md-10" grid-list-sm>
    <v-card class="d-flex" flat>
      <v-card-text class="d-flex">
        <v-layout wrap justify-center>
          <v-flex md4 sm4 xs12>
            <select-field-widget
                v-if="filterOptions.regions.length"
                v-model="filters.region"
                :title="'Region'"
                :inputOptions="filterOptions.regions"
                :inputName="'regions'"
                :initialSelected="initialFilters.region"
                @change="onChange()"
                isRequired
                unSelectFirst></select-field-widget>


          </v-flex>
          <v-flex md4 sm6 xs12>
            <select-field-widget
                v-if="filterOptions.categories.length"
                v-model="filters.category"
                :title="'Vertical'"
                :inputOptions="filterOptions.categories"
                :inputName="'categories'"
                :initialSelected="initialFilters.category"
                @change="onChange()"
                isRequired
                unSelectFirst></select-field-widget>

          </v-flex>

          <v-flex md4 sm6 xs12 v-if="features.isPeriodSelection">
            <select-field-widget
                v-if="filterOptions.periods.length"
                v-model="filters.period"
                :title="'Time Period'"
                :inputOptions="filterOptions.periods"
                :initialSelected="initialFilters.period"
                :inputName="'periods'"
                @change="onChange()"
                isRequired
                unSelectFirst></select-field-widget>
            <v-checkbox
                v-if="isCompareEnable()"
                v-model="filters.includeWoWValues"
                :value="1"
                :label="`Compare to previous period`"
                @click="onChange()"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>

</template>
<script lang="ts">
import {Component, Prop, Watch} from 'vue-property-decorator';
import {Filters, FiltersOptions} from "@/models/Filters";
import BaseComponent from "@/components/base/BaseComponent";
import {clone, isDevEnv, syncFiltersToUrl} from "@/components/utils/utils";
import {ENVIRONMENT, FEATURES} from "@/consts/consts";
import {Getter} from "vuex-class";
import {FeatureFlag} from "@/models/response/BrainpowerApiResponse";

@Component
export default class FiltersMenu extends BaseComponent {
  @Getter('featureFlags', {namespace: 'config'}) featureFlags!: FeatureFlag

  @Prop() filterOptions?: FiltersOptions;
  @Prop() initialFilters?: Filters;

  @Watch('initialFilters')
  onFiltersChanged(val: Filters, oldVal: Filters) {
    this.filters = val
  }

  private filters: Filters = {} as Filters;
  private env = ENVIRONMENT
  private features = FEATURES
  private checkbox: number = null

  mounted(){
    this.filterOptions.periods.sort((a,b)=> a.id - b.id)

    this.filters = clone(this.initialFilters)
  }

  onChange() {
    syncFiltersToUrl(this.filters)
    this.$emit('filterChange', this.filters)
  }
  //TODO: refactor. a function should not have side effects, a getter function for one property should not set the value of another property
  isCompareEnable(): boolean {
    if(isDevEnv()){return true}
    const isEnable = this.filters.period && !this.filters.period.compareDisabled && this.featureFlags['compare-feature']
    this.filters.includeWoWValues = isEnable ? this.filters.includeWoWValues : null
    return isEnable
  }
  
  isDev(): boolean {
    return isDevEnv();
  }

}
</script>

<style lang="scss" scoped>
.filters {
  position: relative;
  top: -30px;
}

.v-select {
  margin: 10px;
}
</style>
